import { TagItems, TagItemsProps } from '../../components/TagItems/TagItems'
import { Signal } from '@preact/signals-react'
import { ComponentType } from 'react'

export const withTags = <P extends object>(
    Component: ComponentType<P>,
    tags: Signal<TagItemsProps['items']>
) => {
    return (props: P) => {
        return tags?.value && Object.keys(tags?.value)?.length ? (
            <>
                <Component {...props} />
                <div style={{ paddingTop: '5px' }}>
                    <TagItems items={tags.value} />
                </div>
            </>
        ) : (
            <Component {...props} />
        )
    }
}
